<script setup>
import { ref } from "vue";
import { Icon } from "@iconify/vue";

const props = defineProps({
  modelValue: { type: String, default: "" },
  id: { type: String, default: "" },
  name: { type: String, default: "" },
  placeholder: { type: String, default: "" },
  autocomplete: { type: String, default: "off" },
  inputClass: { type: String, default: "form-control" },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(["update:modelValue"]);
const isVisible = ref(false);

const toggleVisibility = () => {
  isVisible.value = !isVisible.value;
};
</script>

<template>
  <div class="position-relative">
    <input
      :id="props.id"
      :name="props.name"
      :type="isVisible ? 'text' : 'password'"
      :value="props.modelValue"
      :placeholder="props.placeholder"
      :autocomplete="props.autocomplete"
      :class="[props.inputClass, 'pe-5']"
      :disabled="props.disabled"
      @input="emit('update:modelValue', $event.target.value)"
    />

    <button
      type="button"
      class="btn btn-link position-absolute top-50 end-0 translate-middle-y text-secondary text-decoration-none"
      @click="toggleVisibility"
    >
      <Icon :icon="isVisible ? 'mdi:eye-off-outline' : 'mdi:eye-outline'" width="20" />
    </button>
  </div>
</template>
